import * as React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import { Box } from '@mui/material';


const useStyles = makeStyles((theme) => ({
  root: {
    height: 40,
    borderRadius: '99em',
    border: `1px solid ${theme.palette.line.secondary}`,
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    userSelect: 'none',
    '&:hover': {
      border: `1px solid ${theme.palette.primary.main}`,
    },
  }
}));


/** 圓角按鈕 */
export function ButtonRadius({ content, classesBtn, onClick, disabled }) {

  const classes = useStyles();

  return (
    <Box className={clsx(classesBtn, classes.root, 'transition', { disabled: disabled })} onClick={onClick}>
      {content}
    </Box>
  )
}